<template>
  <div>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Add a technogym staff</md-dialog-title>

      <md-dialog-content>
        <field fieldName="email" ref="email" :validations="{required: true, email: true}" :fieldValue=form.email
          fieldLabel="Email" fieldId="email" :sending="sending" @setfield="setFormField($event)" />
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="hideDialog">Close</md-button>
        <md-button class="md-primary" @click="validateAndSave">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import Field from '@/components/elements/field'
import RepositoryService from '@/services/repositoryService'
import {Constants} from '@/infrastructure/constants'
import NotificationService from '@/services/notificationService'

export default {
  name: 'DialogCustom',
  data: () => ({
    form: {
      email: null
    },
    sending: false,
    actionCompleted: false,
    responseMessage: ''
  }),
  props: ['showDialog', 'parentref'],
  components: {
    Field
  },
  methods: {
    async validateAndSave () {
      var results = []
      for (var property in this.$refs) {
        if (this.$refs.hasOwnProperty(property) && this.$refs[property].validateField) {
          results.push(await this.$refs[property].validateField())
        }
      }
      var canSave = results.every((value) => {
        return value
      })
      if (canSave) {
        this.sending = true
        await NotificationService.manageNotification(this.parentref, await RepositoryService.searchUsersByOperator(this.form),
          async (data) => {
            if (data.totalCount > 0) {
              var createStaffRequest = {
                ...this.form,
                ...{
                  'userId': data.items[0].userId,
                  'role': Constants.technogymStaff_roleId
                }
              }
              await NotificationService.manageNotification(this.parentref, await RepositoryService.createStaffMemberFromUser(createStaffRequest),
                (data) => {
                  this.parentref.$refs.navigationlayout.setNotification('Technogym staff saved')
                  this.$router.go()
                })
            } else {
              this.parentref.$refs.navigationlayout.setNotification('Account not found')
            }
          })
        this.sending = false
        this.hideDialog()
      }
    },
    setFormField (fieldObj) {
      this.form[fieldObj.fieldName] = fieldObj.fieldValue
    },
    hideDialog () {
      this.$emit('hidedialog')
    }
  }
}

</script>

<style lang="scss" scoped>
  .md-dialog {
    max-width: 768px;
  }

</style>
